/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passwordminlength2Inputs */

const zh_auth_passwordminlength2 = /** @type {(inputs: Auth_Passwordminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码至少需要 8 个字符`)
};

const en_auth_passwordminlength2 = /** @type {(inputs: Auth_Passwordminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 8 characters`)
};

const es_auth_passwordminlength2 = /** @type {(inputs: Auth_Passwordminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña debe tener al menos 8 caracteres`)
};

/**
* | output |
* | --- |
* | "Password must be at least 8 characters" |
*
* @param {Auth_Passwordminlength2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_passwordminlength2 = /** @type {((inputs?: Auth_Passwordminlength2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passwordminlength2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_passwordminlength2(inputs)
	if (locale === "en") return en_auth_passwordminlength2(inputs)
	return es_auth_passwordminlength2(inputs)
});
export { auth_passwordminlength2 as "auth_passwordMinLength" }